import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import { SendIcon, ArrowUpIcon, ArrowDownIcon } from 'lucide-react';

const RankingWidget = ({ onAnswer, disabled, options = [], initialValue = null }) => {
  const getInitialItems = () => {
    if (initialValue && Array.isArray(initialValue) && initialValue.length > 0) {
      return initialValue;
    }
    return options;
  };

  const [items, setItems] = useState(getInitialItems);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setItems(getInitialItems());
    setIsSubmitting(false);
  }, [initialValue, options]);

  const moveItem = (index, direction) => {
    const newItems = [...items];
    const newIndex = index + direction;
    if (newIndex >= 0 && newIndex < items.length) {
      [newItems[index], newItems[newIndex]] = [newItems[newIndex], newItems[index]];
      setItems(newItems);
    }
  };

  const handleSubmit = () => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: items });
    }
  };

  return (
    <div className="space-y-2.5">
      <div className="space-y-1.5">
        {items.map((item, index) => (
          <div key={item} className="flex items-center gap-2 bg-succession-bg-primary border border-succession-border py-1.5 px-2 rounded">
            <span className="font-medium text-xs text-succession-text-muted w-5 text-center">{index + 1}</span>
            <span className="flex-1 text-xs text-succession-text-primary">{item}</span>
            <div className="flex flex-col">
              <button
                onClick={() => moveItem(index, -1)}
                disabled={index === 0 || disabled || isSubmitting}
                className="text-succession-text-secondary hover:text-succession-primary disabled:opacity-30"
              >
                <ArrowUpIcon className="h-3.5 w-3.5" />
              </button>
              <button
                onClick={() => moveItem(index, 1)}
                disabled={index === items.length - 1 || disabled || isSubmitting}
                className="text-succession-text-secondary hover:text-succession-primary disabled:opacity-30"
              >
                <ArrowDownIcon className="h-3.5 w-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>
      <Button
        onClick={handleSubmit}
        disabled={disabled || isSubmitting}
        className="w-full text-sm"
        size="sm"
      >
        <SendIcon className="h-3.5 w-3.5 mr-2" />
        Submit Answer
      </Button>
    </div>
  );
};

export default RankingWidget;
